/* istanbul ignore file */
import dynamic from 'next/dynamic';

export const SearchAdServerIntegration = dynamic(
  () => import(/* webpackChunkName: 'SearchAdServerIntegration' */ './SearchAdServerIntegration'),
  { ssr: false },
);
